const { ASYNC } = require('../utils/redux-helpers');

module.exports = {
    SUBMIT_BUG_REPORT: ASYNC
};
